// @ts-check
// Botão Agendar do card no kanban: abre o diálogo de agendamento sem sair do funil.
import { html } from 'htm/preact';
import { useState } from 'preact/hooks';
import { LightIconButton } from '../../ui/button.js';
import { ScheduleEventModal } from './schedule-event-modal.js';
import { t } from '../../i18n/index.js';

/**
 * @param {{ record: any }} props
 */
export function CardScheduleButton({ record }) {
  const [isOpen, setIsOpen] = useState(false);
  return html`<span class="board-card-schedule" data-open=${isOpen ? 'true' : undefined}>
    <${LightIconButton}
      icon="IconCalendarPlus"
      ariaLabel=${t('calendar.cardAction')}
      title=${t('calendar.cardAction')}
      onClick=${(event) => {
        event.stopPropagation();
        setIsOpen(true);
      }}
    />
    ${isOpen
      ? html`<${ScheduleEventModal}
          opportunity=${{ id: record.id, name: record.name ?? '', ownerId: record.ownerId ?? null }}
          onClose=${() => setIsOpen(false)}
        />`
      : null}
  </span>`;
}
